<template>
  <div>
    <v-toolbar>
      <v-toolbar-title>{{ $t('SMARTHOME_DEVICES.ITEMS') }}</v-toolbar-title>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <smart-home-devices-list-filters @setRequest="setRequest" />

      <smart-home-devices-list
        :meta="meta"
        :filters="filters"
        :items="smartHomeDevices"
        @show="edit"
        @refresh="refreshData"
        @show-apartment="showApartment"
      />
    </v-sheet>

    <v-dialog v-model="dialog" persistent max-width="400px">
      <edit-smart-home-device
        v-if="smartHomeDevice.id"
        :id="smartHomeDevice.id"
        @updated="close"
        @cancel="close"
      />
    </v-dialog>

    <v-dialog v-model="apartmentDialogShow" persistent max-width="400px">
      <apartment-show
        v-if="apartmentDialogShow"
        :apartment="smartHomeDevice.apartment"
        :buildings="[smartHomeDevice.apartment.building]"
        @cancel="apartmentDialogShow = !apartmentDialogShow"
        @edit="apartmentDialogEdit = !apartmentDialogEdit"
      />
    </v-dialog>

    <v-dialog v-model="apartmentDialogEdit" persistent max-width="400px">
      <apartment-edit
        v-if="apartmentDialogEdit"
        :apartment="smartHomeDevice.apartment"
        :buildings="[smartHomeDevice.apartment.building]"
        @cancel="apartmentDialogEdit = !apartmentDialogEdit"
        @success="updatedApartment"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SmartHomeDevicesList from '@/modules/smarthome/components/SmartHomeDevicesList';
import SmartHomeDevicesListFilters from '@/modules/smarthome/components/SmartHomeDevicesListFilters';

export default {
  name: 'SmartHomePage',

  components: {
    SmartHomeDevicesList,
    SmartHomeDevicesListFilters,
    EditSmartHomeDevice: () =>
      import('@/modules/smarthome/components/EditSmartHomeDevice.vue'),
    ApartmentShow: () => import('@/components/apartments/Show.vue'),
    ApartmentEdit: () => import('@/components/apartments/Edit.vue')
  },

  data: () => ({
    meta: {},
    filters: {},
    smartHomeDevice: {},
    dialog: false,
    apartmentDialogShow: false,
    apartmentDialogEdit: false
  }),

  computed: {
    ...mapState('smarthome', ['smartHomeDevices'])
  },

  methods: {
    ...mapActions('smarthome', [
      'getSmartHomeDevices',
      'setApartmentSmartHomeDevice'
    ]),

    setRequest(filters) {
      this.filters = filters;
    },

    refreshData(params) {
      this.getSmartHomeDevices(params).then(({ data }) => {
        this.meta = data.meta;
      });
    },

    edit(item) {
      this.smartHomeDevice = item;
      this.dialog = true;
    },

    close() {
      this.smartHomeDevice = {};
      this.dialog = false;
    },

    showApartment(item) {
      this.smartHomeDevice = item;
      this.apartmentDialogShow = true;
    },

    updatedApartment(apartment) {
      this.setApartmentSmartHomeDevice({
        id: this.smartHomeDevice.id,
        apartment
      });
    }
  }
};
</script>
